var axios = require('axios')

// get categories list
axios.getPaymentSimpleList = function (success, callBackError) {
  this.get(process.env.prefix_payment + '/payment-methods')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
// get categories list
axios.getPaymentSimpleListGMS = function (success, callBackError) {
  this.get(process.env.prefix_payment + '/payment-methods-gms')
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getPaymentLogs = function (orderNumber, success, callBackError) {
  this.get(process.env.prefix_payment + '/payment/logs/' + orderNumber)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// Get Merchant payment id
axios.getMerchantPaymentIdDetails = function (storeCode ,success, callBackError) {
  this.get(process.env.prefix_payment + `/merchant-payment-click-id?store_code=${storeCode}`)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// Update Merchant payment id
axios.createOrUpdateMerchantPaymentIdDetails = function (params, success, callBackError) {
  this.post(process.env.prefix_payment + '/merchant-payment-click-id', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}


export default axios



// WEBPACK FOOTER //
// ./src/assets/api/Payment.js